import { Proceeding } from "../pages/proceedings";
import { ReactComponent as StarSvg } from '../images/star.svg';
import './proceedingItem.css';
import { ReactComponent as ModifySvg } from '../images/agenda-item.svg';
import { useNavigate } from "react-router-dom";

interface ProceedingItem {
    proceeding: Proceeding,
    handleStarred: (proceeding: Proceeding) => void,
}

export function ProceedingItem({proceeding, handleStarred}: ProceedingItem) {

    let navigate = useNavigate();

    return (
        <div className="proceeding-item">
            <div className="proceeding-item-desc">
                <p><strong>{proceeding.internalNumber} | {proceeding.open ?? 'Sin fecha'} | {proceeding.signature ? proceeding.signature : 'Sin firma'} | {proceeding.type ?? 'Tipo no específicado'}</strong></p>
                <p>{proceeding.description ? proceeding.description : 'Sin descripción.'}</p>
            </div>
            <StarSvg className={"clickable " + (proceeding.starred == '1' ? 'starred' : '')} onClick={() => handleStarred(proceeding)}/>
            <ModifySvg className="clickable" onClick={() => navigate('modificar', { state: proceeding })}/>
        </div>
    )
}